import { ChangeDetectorRef, Component, inject } from '@angular/core';

import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { TellentBrand } from '@core/tellent-types';
import { WindowRef } from '@core/user-interface-legacy';

import { AccountSetupBundles } from './account-setup-bundles.service';
import { environment } from '../environments/environment';

/* eslint-disable @angular-eslint/prefer-standalone */
@Component({
  selector: 'rto-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less'],
  standalone: false,
})
export class AppComponent {
  private readonly accountSetupBundles = inject(AccountSetupBundles);
  private readonly windowRef = inject(WindowRef);
  protected readonly cdRef = inject(ChangeDetectorRef);

  public loading: boolean = true;
  public isTellentSetup = this.windowRef.nativeWindow.location.hostname.includes(
    TellentBrand.Tellent,
  );

  private ngOnDestroy$ = new Subject<void>();

  public ngOnInit(): void {
    if (this.isTellentSetup) this.useTellentFavicon();

    if (environment.analytics) {
      this.loadGrowsumo();
    } else {
      // TODO remove after testing
      (<any>window).loadGrowsumo = this.loadGrowsumo.bind(this);
    }
  }

  private loadGrowsumo(): void {
    const growsumoBundle = this.accountSetupBundles.create({
      name: 'growsumo',
      url: 'https://snippet.growsumo.com/growsumo.min.js',
    });

    growsumoBundle
      .load()
      .pipe(
        filter(status => status.loaded),
        takeUntil(this.ngOnDestroy$.asObservable()),
      )
      .subscribe(() => {
        const growsumo = (<any>window).growsumo;
        growsumo._initialize(environment.growsumoPublicKey);
      });
  }

  private useTellentFavicon(): void {
    const faviconLink: HTMLLinkElement | null = document.querySelector('link[rel="icon"]');
    if (faviconLink) faviconLink.href = 'assets/favicon-tellent.ico';
  }
}
